import React from "react";
import {Grid, Typography} from "@mui/material";

export default function NessunRisultato() {
    return (
        <Grid className="center" container direction="column" spacing={3}>
            <Grid item>
                <Typography>Nessun risultato</Typography>
            </Grid>
        </Grid>
    );
}
